<template>
  <div id="digital">
    <!-- 全电发票 -->
    <component :is="pageView" @change-page="changePage" />
  </div>
</template>

<script setup name="DigitalInvoice">
import stateTaxHome from './stateTax/home';
import stateTaxLogin from './stateTax/login';
import stateTaxPackage from './stateTax/package';
import stateTaxInvoice from './stateTax/invoice';
import accountCenter from'./accountCenter/index'
import useInvoiceStore from '@/store/modules/invoice';
import { getBlueInvoiceList } from '@/api/invoice';
import {isAlReadyLogin} from "@/views/digitalInvoice/digitalLoginHandler.js";

const props = defineProps({
  currentQa: {
    type: Object,
    default: () => ({}),
  },
});

const useInvoice = useInvoiceStore();
const pageView = shallowRef(stateTaxHome);

onBeforeMount(() => {
  !(function (doc, win) {
    const [baseWidth, baseHeight] = [1920, 1080];
    const baseRate = baseWidth / baseHeight;
    const docEle = doc.documentElement;
    const resizeFnStr = 'orientationchange' in win ? 'orientationchange' : 'resize';
    const resizeFn = () => {
      const docWidth = docEle.clientWidth;
      const docHeight = docEle.clientHeight;
      const winRate = docWidth / docHeight;
      docEle.style.fontSize = `${(docWidth / baseWidth) * 100}px`;
    };
    resizeFn();
    win.addEventListener(resizeFnStr, resizeFn, false);
    doc.addEventListener('DOMContentLoaded', resizeFn, false);
  })(document, window);
});

onMounted(() => {
  const { queType, sonQueType, initialAnswer, solution } = props.currentQa;
  if (queType == '3') {
    if (sonQueType == '34') { // 专票红冲
      useInvoice.$patch((state) => {
        state.redInvoiceList = [...JSON.parse(initialAnswer), ...(solution ? [JSON.parse(solution)] : [])];
      });
    } else if (['31', '32', '33'].includes(sonQueType)){
      useInvoice.$patch((state) => {
        state.blueInvoiceList = solution ? [JSON.parse(solution)] : [];
      });
    }
  }

  if(isAlReadyLogin()) {
    changePage('package')
  }
});

//切换页面时
function changePage(page) {
  switch (page) {
    case 'home':
      pageView.value = stateTaxHome;
      break;
    case 'login':
      pageView.value = stateTaxLogin;
      break;
    case 'package':
      pageView.value = stateTaxPackage;
      break;
    case 'invoice':
      pageView.value = stateTaxInvoice;
      break;
    case 'accountCenter':
      pageView.value = accountCenter;
      break
    case 'stateTaxHome':
      pageView.value = stateTaxHome
  }
}


const getGrandchildValue = inject('getGrandchildValue');
getGrandchildValue.value.getResetData = () => {
  if (['31', '32', '33', '34'].includes(props.currentQa.sonQueType)) {
    useInvoice.$patch({
      blueInvoiceList: [],
      redInvoiceList: [],
    });
  }
  return {
    solution: '',
  };
};

</script>

<style lang="scss" scoped>
#digital {
  position: relative;
  :deep(.el-overlay) {
    position: absolute;
  }
}
</style>
